import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'su',
    fullName: 'Sundanese',
    nativeName: 'Basa Sunda',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "ArgVoid",
    landing_title: "Aya anu Endah Anu Datang",
    landing_subtitle: "ArgVoid mangrupikeun studio pamekaran aplikasi sareng kaulinan. Tetep katala, hal anyar datang pas!",
    select_language: "Pilih Basa",
    search_placeholder: "Pilarian basa...",
    terms_title: "Sarat Service",
    policy_title: "kabijakan privasi",
    cookies_title: "Kawijakan cookie",
    terms_content: `
        <strong>1. Narima Sarat </strong><br>
        Ku ngaksés ArgVoid, Sarat Layanan ieu katampa. Upami syarat-syarat ieu henteu sapuk, jasa éta henteu kedah dianggo.<br><br>

        <strong>2. Pamakéan Platform</strong><br>
        ArgVoid sareng aplikasina disayogikeun "sapertos" pikeun tujuan inpormasi sareng kreatif. Ladenan kedah dianggo ngan ukur pikeun tujuan anu sah.<br><br>

        <strong>3. Kalakuan anu dilarang</strong><br>
        Ngamanfaatkeun kerentanan situs, spamming, atanapi nyobian aksés anu teu sah kana infrastruktur dilarang pisan.<br><br>

        <strong>4. Bantahan</strong><br>
        Platform sareng jasa tiasa dirobih iraha waé tanpa aya bewara. Henteu aya jaminan anu disayogikeun ngeunaan waktos waktos atanapi kasadiaan jasa.
    `,
    policy_content: `
        <strong>1. Koléksi Émbaran</strong><br>
        Platformna henteu meryogikeun auténtikasi pangguna atanapi nyiptakeun akun dina waktos ayeuna. Henteu aya inpormasi idéntitas pribadi (sapertos nami atanapi alamat email) anu aktip dikumpulkeun ti sémah.<br><br>

        <strong>2. Pamakéan Data</strong><br>
        Analisis dasar, anonim tiasa dikumpulkeun pikeun ngartos lalu lintas situs sareng ningkatkeun aplikasi. Data ieu teu numbu ka idéntitas pamaké individu.<br><br>

        <strong>3. Jasa Pihak-katilu</strong><br>
        Panyadia pihak katilu tiasa dianggo pikeun jasa hosting sareng analytics. Prakték privasi panyadia masing-masing ieu ngatur data anonim anu diolah dina infrastrukturna.<br><br>

        <strong>4. Kaamanan Data</strong><br>
        Ukuran kaamanan anu wajar dilaksanakeun pikeun ngajagi platform. Tapi, teu aya padika pangiriman ngaliwatan Internét anu sagemblengna aman.<br><br>
    `,
    cookies_content: `
        <strong>1. Naon Cookies sareng Panyimpenan Lokal?</strong><br>
        Cookies sareng panyimpen lokal browser mangrupikeun file data leutik anu disimpen dina alat pikeun nginget preferensi konfigurasi dina kunjungan.<br><br>

        <strong>2. Tujuan Pamakéan</strong><br>
        Browser LocalStorage dianggo sacara ketat pikeun nyimpen setélan konfigurasi, sapertos:<br>
        - Karesep basa<br>
        - Konfigurasi antarbeungeut pangguna (contona, perenah atanapi setélan téma)<br>
        - Cache aplikasi samentara<br><br>

        <strong>3. Taya Tracking</strong><br>
        Cookies sareng panyimpenan lokal henteu dianggo pikeun iklan atanapi tujuan nyukcruk pihak katilu. Sadaya data anu disimpen leres-leres pikeun fungsionalitas inti platform.<br><br>

        <strong>4. Kontrol</strong><br>
        Data browser bisa diberesihan iraha wae ngaliwatan setelan browser, nu bakal ngareset sagala konfigurasi lokal.
    `,
    cookie_consent_text: "Kami nganggo cookies dasar pikeun mastikeun halaman wéb tiasa dianggo leres, sapertos ngajaga sési anjeun aktip, ngahémat pilihan basa anjeun, sareng konfigurasi khusus anu sanés.",
    read_policy: "Baca Kawijakan Cookie",
    support_title: "Kontak Rojongan",
    support_subject_label: "Subjek",
    support_message_label: "talatah",
    support_submit_button: "Kirim Pesen",
    support_hint: "Catetan: Ieu bakal muka aplikasi email standar anjeun pikeun ngirim pesen.",
    support_success_msg: "Muka aplikasi surélék anjeun...",
    support_error_msg: "Gagal ngirim pesen. Mangga cobian deui engké.",
    explorer_title: "Penjelajah",
    history_title: "Sajarah",
    animation_title: "animasi",
    config_title: "Konfigurasi",
    tool_mouse: "Pilih (Ctrl+M)",
    tool_brush: "Sikat (Ctrl+B)",
    tool_brush_mode: "Toggle Mode (Padet/Hapus)",
    tool_eraser: "pamupus (Ctrl+E)",
    tool_brush_size: "Saluyukeun Ukuran Sikat",
    tool_bucket: "Eusian (Ctrl+F)",
    tool_eyedropper: "Tetes panon",
    tool_grid: "Grid (Ctrl+Shift+B)",
    tool_rotate: "Rotasikeun (Ctrl+Shift+R)",
    tool_flip_h: "Balikkeun H (Ctrl+Shift+H)",
    tool_flip_v: "Balikkeun V (Ctrl+Shift+V)",
    tool_transpose: "Transpose (Ctrl+Shift+T)",
    label_width: "Lebar",
    label_height: "Jangkungna",
    label_frames: "Jumlah Pigura",
    label_animation: "Gaya animasi",
    label_background_color: "Warna Latar",
    label_interval: "Interval",
    tool_anim_config: "Konfigurasi animasi",
    label_new_width: "Lebar Anyar",
    label_new_height: "Jangkungna Anyar",
    label_apply: "Larapkeun",
    label_colors: "Warna-warna",
    label_size: "Ukuran",
    label_tolerance: "Toleransi",
    val_horizontal: "Horizontal",
    val_vertical: "Nangtung",
    val_sequence: "Runtuyan",
    val_bounce: "mumbul",
    val_random: "Acak",
    val_solid: "Padet",
    val_clear: "Jelas",
    action_add_sheet: "Lembaran Anyar",
    action_import: "Impor",
    action_export: "Ékspor",
    action_sort_projects: "Susun",
    sort_date_old: "Pangkolotna Mimiti",
    sort_date_new: "Panganyarna munggaran",
    sort_name_az: "Ngaran (A-Z)",
    sort_name_za: "Ngaran (Z-A)",
    action_new_sprite: "Sprite Anyar",
    action_new_project: "Proyék Anyar",
    modal_save_all_title: "Simpen Sadaya Parobahan",
    modal_save_all_desc: "Pilih aset pikeun disimpen:",
    modal_save_selected: "Simpen Dipilih",
    action_saved: "Disimpen",
    modal_create_sprite_title: "Jieun Sprite Anyar",
    modal_create_project_title: "Jieun Proyék Anyar",
    modal_add_sheet_title: "Tambahkeun Lambaran Anyar",
    modal_rename_sheet_title: "Ganti ngaran Lembar",
    modal_rename_sprite_title: "Ganti ngaran Sprite",
    modal_delete_sprite_title: "Hapus Sprite",
    modal_delete_project_title: "Hapus Proyék",
    modal_delete_sheet_title: "Pupus Lembar",
    placeholder_sprite_name: "Ngaran",
    placeholder_project_name: "Ngaran",
    placeholder_sheet_name: "Ngaran",
    placeholder_new_name: "Ngaran Anyar",
    action_create: "Nyiptakeun",
    action_add: "Tambihan",
    action_rename: "Ganti ngaran",
    action_duplicate: "Duplikat",
    action_delete: "Hapus",
    action_cancel: "Ngabolaykeun",
    confirm_delete_sprite: "Naha anjeun yakin hoyong mupus sprite ieu?",
    confirm_delete_project: "Naha anjeun yakin hoyong ngahapus proyék ieu? Sadaya sprites bakal dipiceun.",
    confirm_delete_sheet: "Naha anjeun yakin hoyong mupus lambaran ieu?",
    err_select_sprite: "Mangga pilih sprite heula.",
    err_select_project: "Mangga pilih proyek heula.",
    err_name_empty: "Ngaran teu tiasa kosong.",
    err_sprite_exists: "A sprite kalawan ngaran éta geus aya.",
    err_project_exists: "Proyék anu nami éta parantos aya.",
    err_no_content: "Taya eusi pikeun nyimpen.",
    err_no_changes: "Taya parobahan pikeun nyimpen.",
    err_delete_last_sheet: "Teu bisa mupus lambaran panungtungan.",
    err_extract_frames: "Teu tiasa nimba pigura naon waé.",
    err_indexeddb: "Gagal nyimpen sacara lokal. Panyungsi anjeun moal ngadukung IndexedDB.",
    msg_upload_success: "Unggahan suksés: {0}",
    msg_upload_failed: "Unggahan Gagal: {0}",
    msg_save_success: "Simpen suksés.",
    msg_saving: "Nyimpen...",
    msg_multi_save_result: "Aset {0} disimpen. {1} gagal.",
    menu_title: "ménu",
    menu_save: "Simpen",
    menu_save_all: "Simpen Sadayana",
    menu_support: "Kontak Rojongan",
    label_local_storage: "Panyimpenan Lokal",
    label_sign_in: "Daptar",
    modal_export_title: "Ékspor Sprite",
    label_filename: "Nami file",
    label_format: "Formatna",
    action_export_confirm: "Ékspor",
};

export default translations;
